export default function(theme) {
  return {

    bottomMargin: {
      marginBottom: theme.spacing.unit * 2
    },

    bold: {
      fontWeight: 'bold'
    },

    actions: {
      padding: `0 ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`
    }

  }
}



// WEBPACK FOOTER //
// ./src/styles/components/CreateKeyModal.js